import React from 'react';
import axios from 'axios';

export default axios.create({
   // baseURL: 'http://localhost/docentedigitalbackend/'
   baseURL: 'https://docentedigital.cybermaq.com/docentedigitalbackend/'
});